import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-LineGraph',
  templateUrl: './LineGraph.component.html',
  styleUrls: ['./LineGraph.component.css']
})
export class LineGraphComponent implements OnInit {

  @Input() dataSo: any;
  @Input() sizeG = false ;

	loginDisplay = false;

  dataSource: any;
  type: string = "Line" ;
  width: string ="0";
  height: string ="0";
  chartData: any;

  constructor() {


  }

  ngOnInit() {
    if(this.sizeG){
          this.width="100%";
          this.height="400"
    } else{
          this.width="600";
          this.height="350";
    }
    this.dataSource = this.dataSo;

  }

}
